import Report from '../components/Report/Index.vue'

let routes = {
    path: '/',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/reports',
            name: 'Report',
            component: Report
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/report.js